"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRoleDetails = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const roleDetailsQuery = (0, client_1.gql) `
  query RoleDetails($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      hidden
      cycleId
      cycleGroupName
      cycleGroup
      calendarOrder
      terminateDate
    }
  }`;
const requestRoleDetails = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(roleDetailsQuery, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role;
};
exports.requestRoleDetails = requestRoleDetails;
